<template>
    <div class="mt-6 mb-6 mediaItem">
        <div v-if="!theme">
            <v-btn :data-cy="name" class="ma-2" color="primary" @click.stop="openDialog"><v-icon left>zmdi-collection-image-o</v-icon> {{ title || 'Choose a file' }}</v-btn>
            <v-text-field v-model="selected" :name="name" type="hidden" style="display: none" required></v-text-field>
            <v-row class="mb-6" no-gutters>
                <v-col class="imgbtn" xs1 v-for="item in files" :key="item.id" :id="`img_${item.id}`">
                    <img @error="fixImg" :src="item.path" width="110" height="90" style="background: #ab9d9d; padding: 6px; border-radius: 7px" />
                    <i @click="() => removeImg(item)" class="mr-3 zmdi zmdi-minus"></i>
                    <label style="display: block">{{ item.title }}</label>
                </v-col>
            </v-row>
        </div>
        <div v-if="editor && files.length">
            <v-btn class="ma-2" color="#9C27B0" @click.stop="() => editor(files)">Insert</v-btn>
        </div>

        <div class="thumb-wrap ml-auto" v-if="theme == 'product'" @click.stop="openDialog">
            <v-col v-for="item in files" :key="item.id">
                <v-img :src="item.path" style="height: 70px; width: 100px !important" />
            </v-col>
            <v-img v-if="files.length <= 0" src="https://via.placeholder.com/625x800" style="height: 70px" />
            <div class="edit-btn d-flex justify-center align-items-center">
                <v-icon dark>add</v-icon>
            </div>

            <v-text-field v-model="selected" :name="name" type="hidden" style="display: none" required></v-text-field>
        </div>

        <div v-if="theme == 'product_featured'" @click.stop="openDialog">
            <v-img v-if="files.length <= 0" src="https://via.placeholder.com/625x800" style="width: 100%" />
            <v-col v-for="item in files" :key="item.id">
                <v-img :src="item.path" style="width: 100%" />
            </v-col>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    props: ['values', 'dialog', 'selected', 'multiple', 'name', 'current', 'title', 'theme', 'the_files', 'editor'],
    data() {
        return {
            files: []
        }
    },
    computed: {
        ...mapGetters(['media'])
    },
    mounted() {
        if (this.selected && this.selected.length > 0) {
            let ids = this.selected.filter((value, index) => {
                return this.selected.indexOf(value) === index
            })
            let _ids = this.media.data.map((m) => {
                if (ids.indexOf(m.id) > -1) {
                    return m.id
                }
            })
            ids = ids.filter((id) => {
                return _ids.indexOf(id) < 0
            })
            if (ids.length > 0) {
                this.$store.dispatch('getIDsToMedia', ids)
            }
        }

        this.refresh()
    },
    methods: {
        openDialog() {
            this.$emit('update:current', this.name)
            this.$emit('update:dialog', true)
        },
        refresh() {
            let media = this.$store.getters.media
            var self = this
            this.files =
                this.$store.getters.media && this.$store.getters.media.data !== null
                    ? this.$store.getters.media.data.filter((item) => {
                          return self.selected ? self.selected.includes(item.id) : self.selected
                      })
                    : []

            this.$emit('update:the_files', this.files)
        },
        removeImg(item) {
            this.selected.map((v, i) => {
                if (v == item.id) {
                    this.selected[i] = null
                }
            })
            this.files.map((v, i) => {
                if (v.id == item.id) {
                    this.files.splice(v)
                }
            })
        }
    },
    watch: {
        selected: function (val) {
            // if( !this.selected || this.selected.length <= 0 ) return;
            this.refresh()
        }
    },
    multiple: function () {
        this.$emit('update:multiple', this.multiple)
    },
    files: function (val) {
        this.$emit('update:the_files', val)
    }
}
</script>
<style scoped>
.mediaItem {
    display: inline-block;
}
.imgbtn i {
    position: absolute;
    right: -5px;
    top: -4px;
    width: 20px;
    height: 20px;
    color: white;
    background: red;
    border-radius: 50%;
    text-align: center;
    line-height: 20px;
    font-weight: bold;
}
.imgbtn {
    position: relative;
}
</style>
